import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const CourseDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsCourseDetails" */ 'modules/activityDetails/CourseDetails/pages/CourseDetails'
    )
)

const CourseDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:courseId`} component={CourseDetails} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default CourseDetailsRouting
